import {
  ROUTE_HOMEPAGE,
  ROUTE_LANDING,
  ROUTE_LOGIN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_UPLOAD_FIRST_BILL,
} from '@1bill-app/constants';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { formatMobileNumber } from '@1bill-app/services/custom-functions/custom-functions';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { RewardActionCodeMapping } from '@1bill-app/services/reward/reward.type';
import { StorageItemKeys, StorageService } from '@1bill-app/services/storage.service';
import {
  getCountryPhoneNumber,
  PhoneValidator,
} from '@1bill-app/services/validation/phone.validator';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { SubSink } from 'subsink';
import ERROR_MSGS from './error-msgs';
@Component({
  selector: 'app-mobile-number',
  templateUrl: './mobile-number.page.html',
  styleUrls: ['./mobile-number.page.scss'],
})
export class MobileNumberPage implements OnInit, OnDestroy {
  isLoading$ = this.rewardQuery.isLoading$;
  subs = new SubSink();
  public _source: string;
  landingPage = ROUTE_LANDING;
  mobileForm: FormGroup;
  /* Flag property */
  // public loading: boolean;
  public isAuthLoading$ = this.authQuery.isLoading$;
  public showError = false;
  /* state property */
  public error$ = this.authQuery.selectError();
  verifyMobileRewardPoint$ = this.rewardQuery.getProfileRewardPoint(
    RewardActionCodeMapping.VERIFY_MOBILE_NUMBER,
  );
  /* others */
  public errorMsgs = ERROR_MSGS;
  constructor(
    private authService: AuthService,
    private navCtrl: NavController,
    private logger: NGXLogger,
    private authQuery: AuthQuery,
    public platform: Platform,
    private storageService: StorageService,
    public toastController: ToastController,
    public route: ActivatedRoute,
    public rewardQuery: RewardQuery,
  ) {
    const mobileNumber = this.route.snapshot.queryParamMap.get('mobile');
    this._source = this.route.snapshot.queryParamMap.get('_source');
    this.mobileForm = new FormGroup({
      mobileNumber: new FormControl(getCountryPhoneNumber(mobileNumber), [
        Validators.required,
        PhoneValidator.validCountryPhone('AU'),
      ]),
    });
  }

  ngOnInit() {
    // const email = this.authQuery.getValue().credentials?.email;
    // if (!email) {
    //   this.navCtrl.navigateBack([ROUTE_CREATE_ACCOUNT]);
    // }
    this.subs.sink = this.rewardQuery.getRewardsCache().subscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  async onClickSkip() {
    if (this._source === 'null' || this._source === null) {
      this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
    } else if (this._source) {
      this.navCtrl.navigateForward([this._source]);
    } else if (await this.storageService.getItem(StorageItemKeys.FIRST_BILL_UPLOADED)) {
      this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
    } else {
      this.navCtrl.navigateForward([ROUTE_UPLOAD_FIRST_BILL]);
    }
  }
  get mobileCtrl() {
    return this.mobileForm.get('mobileNumber');
  }
  get mobileClass() {
    return this.showError && this.mobileCtrl.invalid && this.mobileCtrl.touched ? 'error' : '';
  }

  get phoneEntered() {
    return !this.mobileForm.get('mobileNumber').getError('required');
  }
  get phoneValid() {
    return !this.mobileForm.get('mobileNumber').getError('validCountryPhone');
  }

  initVerifyMobile() {
    this.showError = true;

    this.mobileForm.markAllAsTouched();
    if (!this.phoneEntered) {
      return;
    }

    const { mobileNumber } = this.mobileForm.getRawValue();
    this.logger.log('mobileNumber', mobileNumber);

    if (this.mobileForm.invalid) {
      this.logger.debug(this.mobileForm.get('mobileNumber').errors);
      return;
    }

    const formattedMobile = formatMobileNumber(mobileNumber);
    this.logger.log('formattedMobile', formattedMobile);
    this.authService
      .addMobileNumber(formattedMobile)
      .toPromise()
      .then((res) => {
        if (!res) {
          // filtered out if mobile already exists
          this.mobileAlreadyPresent(formattedMobile);
          return;
        } else if (res.alreadyVerified) {
          this.alreadyVerifiedToast();
          this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
        } else {
          this.navCtrl.navigateForward([ROUTE_MOBILE_VERIFICATION]);
        }
      })
      .catch((err) => {
        this.logger.error('this.authService.addMobileNumber', err);
        this.showError = true;
        if (
          err &&
          err.code === 'NotAuthorizedException' &&
          err.message.includes('Current status is CONFIRMED')
        ) {
          setTimeout(() => {
            this.navCtrl.navigateForward([ROUTE_LOGIN]);
          }, 400);
        }
      });
  }

  async alreadyVerifiedToast() {
    const toast = await this.toastController.create({
      message: 'Your mobile has previously been verified. If you want to update your mobile number, please contact 1Bill support.',
      duration: 5000,
      color: 'success',
    });
    toast.present();
  }
  async mobileAlreadyPresent(mobileNumber: string) {
    const toast = await this.toastController.create({
      message: `Mobile number ${mobileNumber} is already associated with another 1Bill account.`,
      duration: 5000,
      color: 'warning',
    });
    toast.present();
  }
}
